module.exports = __webpack_public_path__ + "img/news-title-zh.25e3974c.png";